var React = require('react');

function IconHeart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#142B6F","d":"M17.482,38.75c-0.683,0-1.279-0.461-1.451-1.121l-4.549-17.437l-1.549,5.937\tc-0.172,0.66-0.769,1.121-1.451,1.121h-9.989c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5h8.83l2.708-10.379\tc0.172-0.66,0.769-1.121,1.451-1.121s1.279,0.461,1.451,1.121l4.549,17.437l7.549-28.937c0.172-0.66,0.768-1.121,1.451-1.121\tc0.682,0,1.279,0.461,1.451,1.121l5.707,21.879h7.867c0.828,0,1.5,0.672,1.5,1.5s-0.672,1.5-1.5,1.5h-9.025\tc-0.684,0-1.279-0.461-1.451-1.121L26.482,8.692l-7.549,28.937C18.761,38.289,18.165,38.75,17.482,38.75z"}));
}

IconHeart.defaultProps = {"id":"Capa_12","width":"50","height":"50","x":"0","y":"0","enableBackground":"new -5 -5 50 50","version":"1.1","viewBox":"-5 -5 50 50","xmlSpace":"preserve"};

module.exports = IconHeart;

IconHeart.default = IconHeart;
